<button mat-dialog-close class="close-btn-icon"><i class="material-icons">close</i></button>

<mat-dialog-content>
  <ng-content select="[content]"></ng-content>
</mat-dialog-content>
